import React from "react";
import { CheckCircle, XCircle } from "@phosphor-icons/react";

export default function ClaimsPanel({ claims }) {
  if (!claims || claims.length === 0) return null;
  const allowed = claims.filter((c) => c.allowed);
  const prohibited = claims.filter((c) => !c.allowed);

  return (
    <div className="rounded-lg border border-stone-200 bg-white p-5" data-testid="claims-panel">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-stone-500">Compliance Check</div>
          <h3 className="font-semibold text-lg mt-1">Nutrient Content Claims</h3>
        </div>
        <div className="text-xs text-stone-500">
          {allowed.length} allowed · {prohibited.length} prohibited
        </div>
      </div>
      <div className="text-xs text-stone-500 mt-1">
        Per 21 CFR 101.13 / 101.54 / 101.60 / 101.61 / 101.62 — calculated from unrounded values per FDA guidance.
      </div>

      {allowed.length > 0 && (
        <div className="mt-4">
          <div className="text-[11px] uppercase tracking-wider font-bold text-emerald-800 mb-2">You may claim:</div>
          <div className="flex flex-wrap gap-2">
            {allowed.map((c) => (
              <div key={c.claim}
                className="flex items-center gap-1.5 rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1 text-xs text-emerald-900"
                title={`${c.reference} · threshold ${c.threshold}`}
                data-testid={`claim-allowed-${c.claim}`}>
                <CheckCircle size={12} weight="fill" />
                <span className="font-medium">{c.claim}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {prohibited.length > 0 && (
        <details className="mt-5">
          <summary className="text-[11px] uppercase tracking-wider font-bold text-stone-600 cursor-pointer">
            You may NOT claim ({prohibited.length})
          </summary>
          <div className="mt-2 grid sm:grid-cols-2 gap-2">
            {prohibited.map((c) => (
              <div key={c.claim} className="flex items-start gap-2 rounded border border-stone-200 bg-stone-50 px-2 py-1.5 text-xs"
                data-testid={`claim-prohibited-${c.claim}`}>
                <XCircle size={14} weight="fill" className="text-stone-400 shrink-0 mt-0.5" />
                <div>
                  <div className="font-medium text-stone-700">{c.claim}</div>
                  <div className="text-[10px] text-stone-500">{c.reason}</div>
                </div>
              </div>
            ))}
          </div>
        </details>
      )}
    </div>
  );
}
